import {
	GetRelatedPeopleForPerson,
	PersonRelationType,
	PersonType,
} from '@dealstack/shared/lib/generated';
import { I18Namespaces } from '@dealstack/shared/lib/common/i18n/i18n.ts';
import { TranslateFunction } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks.types';
import { getRelationLabelByTypeAndPersonType } from '@dealstack/frontend/app/pages/Project/Cap/CapEntityManageFlow/tabs/BasicDetails/components/EditRelatedPersonDrawer/utils/relatedPeopleLabel.ts';
import { RelatedPersonRow } from '@dealstack/frontend/app/pages/Project/Cap/CapEntityManageFlow/tabs/BasicDetails/components/RelatedPersonsSection/RelatedPersonsSection.types.ts';

export const RELATED_PERSON_RELATION_TYPES: PersonRelationType[] = [
	PersonRelationType.REPRESENTATIVE,
	PersonRelationType.UBO,
	PersonRelationType.PSC,
	PersonRelationType.DIRECTOR,
	PersonRelationType.TRUSTEE,
	PersonRelationType.SETTLER_OR_GRANTOR,
	PersonRelationType.PROTECTOR_OR_ENFORCER,
	PersonRelationType.BENEFICIARY,
	PersonRelationType.OTHER,
];

export const makeRelatedPersonTypeOptions = (
	tCapManage: TranslateFunction<I18Namespaces.CAP_MANAGE>,
	personType: PersonType
) =>
	RELATED_PERSON_RELATION_TYPES.map((type) => ({
		label: getRelationLabelByTypeAndPersonType(tCapManage, type, personType),
		value: type,
	}));

/**
 * Flattens the grouped related-people response into a single list of rows, grouped
 * by relationship type in RELATED_PERSON_RELATION_TYPES order.
 */
export const mapResponseToRelatedPersonRows = (
	response: GetRelatedPeopleForPerson | undefined
): RelatedPersonRow[] => {
	if (!response) {
		return [];
	}

	return RELATED_PERSON_RELATION_TYPES.flatMap((relationType) =>
		(response[relationType] ?? []).map((person) => ({
			relationId: person.relationId,
			personId: person.id,
			displayName: person.displayName,
			email: person.email,
			relationType,
			customRelationType: person.customRelationType,
		}))
	);
};
